import { color, Common } from '@stockbit/ui';
import Image from 'global/Image';
import { useSelector } from 'react-redux';
import { selectors as profileSelectors } from 'lib/entities/profile';
import { ButtonIcon, FooterWeb } from '../styled';

const { Flex, Text, Iconmoon, IconWrapper } = Common;

interface WebProps {
  likes: number;
  liked: string | number;
  isAuthor: number;
  showInsight: boolean;
  onClickInsight: () => void;
  onClickLike: () => void;
  onClickLikers: () => void;
  onClickShare: () => void;
  onClickTipping: () => void;
  onClickComment: (val: any) => void;
}

function Web({
  likes,
  liked,
  isAuthor,
  showInsight,
  onClickInsight,
  onClickLike,
  onClickLikers,
  onClickShare,
  onClickTipping,
  onClickComment,
}: WebProps) {
  const { data: profileData } = useSelector(profileSelectors);
  const { country = 'ID' } = profileData;
  return (
    <>
      {likes > 0 && (
        <Text as="a" className="likes-info" onClick={onClickLikers}>
          {likes} like{likes > 1 && 's'}
        </Text>
      )}
      <FooterWeb justify="space-between" align="flex-end">
        <Flex align="flex-end">
          <div>
            <Flex padding="0 20px 0 0">
              <IconWrapper onClick={onClickLike}>
                {liked ? (
                  <Image
                    src="/icon/post-stream/like-fill.svg"
                    alt="Like post filled"
                    style={{ width: '20px' }}
                  />
                ) : (
                  <Image
                    src="/icon/post-stream/like.svg"
                    alt="Like post"
                    style={{ width: '20px' }}
                  />
                )}
              </IconWrapper>
            </Flex>
          </div>
          <Flex padding="0 20px 0 0">
            <IconWrapper onClick={onClickShare}>
              <Image
                src="/icon/post-stream/share.svg"
                alt="Share post"
                style={{ width: '20px', height: '20px' }}
              />
            </IconWrapper>
          </Flex>
          {showInsight && (
            <IconWrapper padding="0 20px 0 0" onClick={onClickInsight}>
              <Iconmoon
                className="icon-new_analytics"
                size="16px"
                color={color.dimgray}
                hoverColor={color.dimgray}
              />
            </IconWrapper>
          )}
          {!isAuthor && country === 'ID' && (
            <ButtonIcon padding="0 20px 0 0" onClick={onClickTipping}>
              <Image
                src="/icon/post-stream/icon-tip.svg"
                alt="Icon Tip"
                style={{ width: '20px' }}
              />
            </ButtonIcon>
          )}
        </Flex>

        <IconWrapper onClick={onClickComment}>
          <Image
            src="/icon/post-stream/comment.svg"
            alt="Icon Comment New"
            style={{ width: '20px' }}
          />
        </IconWrapper>
      </FooterWeb>
    </>
  );
}

export default Web;
